// extracted by mini-css-extract-plugin
module.exports = {"heading":"HappinessByTheHandful_heading__CJUpe","body":"HappinessByTheHandful_body__VXBkK"};